// @ts-nocheck
import React, { useCallback } from 'react';
import { Autocomplete, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getErrorHelperText, isValueEmpty } from '../../../../utils/Utils';
import CustomPopover from '../../CustomPopover';
import { ReactComponent as DropdownArrow } from '../../../../assets/images/DropdownArrow.svg';

const getOptionLabel = (option) =>
  `${option?.filterName} (${option?.userOfFilter})`;
const isOptionEqualToValue = (option, value) => {
  return option?.filterName === value?.filterName;
};
const RenderCheckListDataTypeAutocomplete = ({
  filters,
  allDetailsFormikForm,
  // section,
  attribute,
}) => {
  const handleFilterNameChange = useCallback(
    (_e, newValue) => {
      if (isValueEmpty(newValue)) {
        allDetailsFormikForm?.setFieldValue(`${attribute?.id}`, '');
        return;
      }
      allDetailsFormikForm?.setFieldValue(`${attribute?.id}`, {
        ...newValue,
        type: 'savedSearch',
        checkedEntity: [],
      });
    },
    [allDetailsFormikForm, attribute]
  );

  const handleRenderOptions = useCallback(
    (props, option) => {
      return (
        <li {...props} key={option?.filterName}>
          <Typography variant="body6">{`${option?.filterName} (${option?.userOfFilter})`}</Typography>{' '}
        </li>
      );
    },
    [attribute, filters]
  );
  const renderAttributesTextField = useCallback(
    (params) => (
      <TextField
        {...params}
        slotProps={{
          ...params?.slotProps,
          inputLabel: { ...params?.slotProps?.inputLabel, shrink: true },
        }}
        error={Boolean(
          getErrorHelperText(
            allDetailsFormikForm?.errors?.[attribute?.id],
            allDetailsFormikForm?.touched?.[attribute?.id]
          )
        )}
        helperText={getErrorHelperText(
          allDetailsFormikForm?.errors?.[attribute?.id],
          allDetailsFormikForm?.touched?.[attribute?.id]
        )}
        // label="Saved filter"
        placeholder="Select saved filter"
        spellCheck={true}
      />
    ),
    [attribute, allDetailsFormikForm]
  );
  return (
    <Autocomplete
      sx={{
        '.MuiFormControl-root': {
          mt: 0,
        },
      }}
      slots={{
        popper: CustomPopover,
      }}
      id="EntityName"
      options={filters?.map((entity) => {
        return {
          filterName: entity?.name,
          entityType: entity?.entity_type,
          userOfFilter: entity?.user,
        };
      })}
      disableClearable={isValueEmpty(
        allDetailsFormikForm.values?.[attribute?.id]
      )}
      value={
        isValueEmpty(allDetailsFormikForm.values?.[attribute?.id])
          ? null
          : allDetailsFormikForm.values?.[attribute?.id]
      }
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      onChange={handleFilterNameChange}
      noOptionsText="No options available."
      popupIcon={<DropdownArrow />}
      renderOption={handleRenderOptions}
      renderInput={renderAttributesTextField}
    />
  );
};

export default RenderCheckListDataTypeAutocomplete;
RenderCheckListDataTypeAutocomplete.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object]))
    .isRequired,
  allDetailsFormikForm: PropTypes.oneOfType([PropTypes.object]).isRequired,
  attribute: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
